<template>
  <div style="height: 100%; width: 100%;">
    <div style="height: 98%; width: 100%; position: absolute; top:2%">
      <!-- 左边部分 -->
      <div class="left">
        <div class="leftbox">
          <div class="user_skills">
            <vue3-seamless-scroll :list="gun_car" class="scroll" :step="0.5">
              <div class="item" v-for="(item, index) in gun_car" :key="index">
                <span>新增车辆{{ item.name }}</span>
              </div>
            </vue3-seamless-scroll>
          </div>
          <div style="height: 26%; width: 100%">
            <div class="title_back">
              <div style="bottom: 65%; position: absolute; left: 3%">车辆数据</div>
            </div>
            <div style="  height: 90%; width: 100%;  display: flex; color: #ffffff;  margin-top: 4%; ">
              <div
                style="  width: 27%; height: 100%;   display: flex;    align-content: center;    justify-content: center;        padding-top: 4%;       ">
                <div style="height: 100%; width: 100%">
                  <div class="left_img">
                    <div style="font-size: 20px">{{ car_total }}</div>
                  </div>
                  <div style="font-size: 1.2rem; text-align: center; margin-top: 13%">车辆总数</div>
                </div>
              </div>
              <div style=" height: 100%;  width: 73%;
                                        font-size: 1rem;
                                        text-align: center;
                                      ">
                <div style="
                                          height: 40%;
                                          width: 100%;
                                          display: flex;
                                          justify-content: center;
                                          align-content: center;
                                          padding-top: 4%;
                                        ">
                  <div style="width: 32%; height: 100%; margin-left: 4%">
                    <div style="color: #ff6666; font-size: 1.2rem">{{ car_data_value[0] }}</div>
                    <div style="padding-top: 15px">{{ car_data_name[0] }}</div>
                  </div>
                  <div style="width: 32%; height: 100%">
                    <div style="color: #ffbf31; font-size: 1.2rem">{{ car_data_value[1] }}</div>
                    <div style="padding-top: 15px">{{ car_data_name[1] }}</div>
                  </div>
                  <div style="width: 32%; height: 100%">
                    <div style="color: #ffbf31; font-size: 1.2rem">{{ car_data_value[2] }}</div>
                    <div style="padding-top: 15px">{{ car_data_name[2] }}</div>
                  </div>
                </div>
                <div style=" height: 50%;  width: 100%; display: flex; justify-content: center;align-content: center; ">
                  <div style="width: 32%; height: 100%; margin-left: 4%">
                    <div style="color: #1eff9e; font-size: 1.2rem">{{ car_data_value[3] }}</div>
                    <div style="padding-top: 15px">{{ car_data_name[3] }}</div>
                  </div>
                  <div style="width: 32%; height: 100%">
                    <div style="color: #1eddff; font-size: 1.2rem">{{ car_data_value[4] }}</div>
                    <div style="padding-top: 15px">{{ car_data_name[4] }}</div>
                  </div>
                  <div style="width: 32%; height: 100%">
                    <div style="color: #f17aff; font-size: 1.2rem">{{ car_data_value[5] }}</div>
                    <div style="padding-top: 15px">{{ car_data_name[5] }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="height: 30%; width: 100%">
            <div class="title_back">
              <div style="bottom: 65%; position: absolute; left: 3%">能耗数据</div>
            </div>
            <div class="left2" id="left3"></div>
          </div>
          <div style="height: 30%; width: 100%">
            <div class="title_back">
              <div style="bottom: 65%; position: absolute; left: 3%">里程数据</div>
            </div>
            <div class="left2" id="left2"></div>
          </div>
        </div>
      </div>
      <!-- 中间部分 -->
      <div class="middle">
        <div style="width: 25%; height: 100%"></div>
        <div style=" width: 50%;height: 100%; float: right; display: flex; justify-content: space-around; ">
          <div class="middle_li" @click="go_con()">
            <div style="height: 40%; width: 15%"></div>
            <div style="width: 50%">
              <p>运营车辆</p>
              <p style="padding-top: 6px; font-size:0.8rem">
                <span style="color: #ffdd00; font-size: 1rem;padding-right: 10px">{{ car_total }}</span>辆
              </p>
            </div>
          </div>
          <div class="middle_li2">
            <div style="height: 50%; width: 15%"></div>
            <div style="width: 50%">
              <p>总里程</p>
              <p style="padding-top: 6px; font-size: 0.8rem">
                <span style="color: #00b7ee; font-size:1rem; ">{{ middle.total_mileage }}</span>
              </p>
            </div>
          </div>
          <div class="middle_li3">
            <div style="height: 40%; width: 15%"></div>
            <div style="width: 50%">
              <p>总能耗</p>
              <p style="padding-top: 6px; font-size: 0.8rem">
                <span style="color: #0ef06c; font-size: 1rem; padding-right: 10px">{{
                  middle.total_consumption
                }}</span>Kwh
              </p>
            </div>
          </div>
          <div class="middle_li4" v-show="divshow" @click="g_bug_list()">
            <div style="height: 40%; width: 15%"></div>
            <div style="width: 47%">
              <p>当前报警</p>
              <p style="padding-top: 6px;font-size: 0.8rem;">
                <span style="color: #ff0055; font-size: 1rem; padding-right: 10px">{{ alertnum }}</span>个
              </p>
            </div>
          </div>
          <div class="middle_li5" v-show="!divshow" @click="g_bug_list()">
            <div style="height: 40%; width: 15%"></div>
            <div style="width: 47%">
              <p>当前报警</p>
              <p style="padding-top: 6px;font-size: 0.8rem; ">
                <span style="color: #ff0055; font-size: 1rem; padding-right: 10px">{{ alertnum }}</span>个
              </p>
            </div>
          </div>
        </div>
        <div style="width: 25%; height: 100%; float: right"></div>
      </div>
      <!-- 右边部分 -->
      <div class="right">
        <div class="rightbox">
          <div style="
                                    height: 10%;
                                    width: 100%;
                                    display: flex;
                                    justify-content: center;
                                    align-content: center; ">
            <div style="
                                      height: 60%;
                                      width: 100%;
                                      display: flex;
                                      justify-content: center;
                                      align-content: center;
                                    ">
              <div class="weather"></div>
              <div style="
                                        width: 80%;
                                        height: 100%;
                                        color: #ffffff;
                                        font-size: 1rem;
                                        padding-left: 5%;
                                      ">
                <div style="display: flex; align-content: center; padding-top: 5px">
                  <div style="width: 25%; color: orange; font-size: 1rem">{{ weather.temperature }}°C</div>
                  <div style="width: 30%">{{ weather.weather }}</div>
                  <div style="width: 30%">{{ weather.city }}</div>
                </div>
                <div style="width: 100%;padding-top: 10px" id="time">{{ nowDate }}</div>
              </div>
            </div>
          </div>
          <div style="height: 22%; width: 100%">
            <div class="title_back">
              <div style="bottom: 65%; position: absolute; left: 3%">驾驶模式</div>
            </div>
            <div class="right2" :id="cright1"></div>
          </div>
          <div style="height: 23%; width: 100%">
            <div class="title_back">
              <div style="bottom: 65%; position: absolute; left: 3%">车辆在线统计</div>
            </div>
            <div style="
                                      width: 85%;
                                      height: 10%;
                                      color: #00ffff;
                                      padding-top: 1%;
                                      text-align: center;
                                      padding-left: 15%;
                                    ">
              <!-- <div style="float: left; font-size: 12px">
                <span style="font-size: 12px">今日在线车辆</span>
                <span
                  style="font-size: 16px; padding-left: 20px"
                  id="online_day"
                >{{ right2.day_count }}</span>
              </div>-->
              <!-- <div style="font-size: 12px">
                <span style="font-size: 12px">当前在线车辆</span>
                <span style="font-size: 16px; padding-left: 20px" id="online_count">{{ onlinenum }}</span>
              </div> -->
            </div>
            <div class="right2" :id="cright2"></div>
          </div>
          <div style="height: 24%; width: 100%">
            <div class="title_back">
              <div style="bottom: 65%; position: absolute; left: 3%">设备故障统计</div>
            </div>

            <div class="right2" :id="cright3"></div>
          </div>
          <div style="height: 20%; width: 100%">
            <div class="title_back">
              <div style="bottom: 65%; position: absolute; left: 3%">设备状态</div>
            </div>

            <div style="width: 100%; height: 90%; margin-top: 3%; margin-left: 3%">
              <div style="width: 100%; height: 45%; display: flex">
                <div class="right_back" v-if="car_status[0]">
                  <div class="right5">
                    <div style="padding-right: 6%">{{ car_status_data.name[0] }}</div>
                  </div>
                  <div style=" height: 100%; width: 85%;font-size: 18px; color: #ffffff;float: left;text-align: center;">
                    <div
                      style="width: 100%;height: 50%;  display: flex; font-size: 14px;  align-items: center;   justify-content: center; ">
                      <div style="width: 33%; color: #ffdd00">{{ car_status_data.value[0].bug }}</div>
                      <div style="width: 33%; color: #17f985">{{ car_status_data.value[0].online }}</div>
                      <div style="width: 33%">{{ car_status_data.value[0].offline }}</div>
                    </div>
                    <div style="width: 100%;height: 40%;display: flex; font-size: 14px;">
                      <div
                        style=" width: 280px; height: 40px;  display: flex;text-align: center;justify-content: center;align-items: center;">
                        <div style="width: 33%; color: #ffdd00">故障</div>
                        <div style="width: 33%; color: #17f985">正常</div>
                        <div style="width: 33%">离线</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="width: 5%; height: 100%; float: left"></div>
                <div class="right_back" v-if="car_status[1]">
                  <div class="right5">
                    <div style="padding-right: 6%">{{ car_status_data.name[1] }}</div>
                  </div>
                  <div style="height: 100%;width: 85%;  font-size: 18px;color: #ffffff;float: left; text-align: center;">
                    <div
                      style=" width: 100%;  height: 50%;display: flex;  font-size: 14px; align-items: center;justify-content: center;">
                      <div style="width: 33%; color: #ffdd00">{{ car_status_data.value[1].bug }}</div>
                      <div style="width: 33%; color: #17f985">{{ car_status_data.value[1].online }}</div>
                      <div style="width: 33%">{{ car_status_data.value[1].offline }}</div>
                    </div>

                    <div style=" width: 100%;
                                              height: 40%;
                                              display: flex;
                                              font-size: 14px;
                                            ">
                      <div style="
                                                width: 280px;
                                                height: 40px;
                                                display: flex;
                                                text-align: center;
                                                justify-content: center;
                                                align-items: center;
                                              ">
                        <div style="width: 33%; color: #ffdd00">故障</div>
                        <div style="width: 33%; color: #17f985">正常</div>
                        <div style="width: 33%">离线</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="width: 100%; height: 5%"></div>
              <div style="width: 100%; height: 45%; display: flex">
                <div class="right_back" v-if="car_status[2]">
                  <div class="right5">
                    <div style="padding-right: 6%">{{ car_status_data.name[2] }}</div>
                  </div>
                  <div style=" height: 100%;
                                            width: 85%;
                                            font-size: 18px;
                                            color: #ffffff;
                                            float: left;
                                            text-align: center;
                                          ">
                    <div style="
                                              width: 100%;
                                              height: 50%;
                                              display: flex;
                                              font-size: 14px;
                                              align-items: center;
                                              justify-content: center;
                                            ">
                      <div style="width: 33%; color: #ffdd00">{{ car_status_data.value[2].bug }}</div>
                      <div style="width: 33%; color: #17f985">{{ car_status_data.value[2].online }}</div>
                      <div style="width: 33%">{{ car_status_data.value[2].offline }}</div>

                    </div>

                    <div style="
                                              width: 100%;
                                              height: 40%;
                                              display: flex;
                                              font-size: 14px;
                                            ">
                      <div style="
                                                width: 280px;
                                                height: 40px;
                                                display: flex;
                                                text-align: center;
                                                justify-content: center;
                                                align-items: center;
                                              ">
                        <div style="width: 33%; color: #ffdd00">故障</div>
                        <div style="width: 33%; color: #17f985">正常</div>
                        <div style="width: 33%">离线</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="width: 5%; height: 100%; float: left"></div>
                <div class="right_back" v-if="car_status[3]">
                  <div class="right5">
                    <div style="padding-right: 6%">{{ car_status_data.name[3] }}</div>
                  </div>
                  <div style="height: 100%; width: 85%;   font-size: 18px;
                                            color: #ffffff;
                                            float: left;
                                            text-align: center;
                                          ">
                    <div style="
                                              width: 100%;
                                              height: 50%;
                                              display: flex;
                                              font-size: 14px;
                                              align-items: center;
                                              justify-content: center;
                                            ">
                      <div style="width: 33%; color: #ffdd00">{{ car_status_data.value[3].bug }}</div>
                      <div style="width: 33%; color: #17f985">{{ car_status_data.value[3].online }}</div>
                      <div style="width: 33%">{{ car_status_data.value[3].offline }}</div>
                    </div>

                    <div style="
                                              width: 100%;
                                              height: 40%;
                                              display: flex;
                                              font-size: 14px;
                                            ">
                      <div style="
                                                width: 280px;
                                                height: 40px;
                                                display: flex;
                                                text-align: center;
                                                justify-content: center;
                                                align-items: center;
                                              ">
                        <div style="width: 33%; color: #ffdd00">故障</div>
                        <div style="width: 33%; color: #17f985">正常</div>
                        <div style="width: 33%">离线</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部 -->
      <div
        style="height: 25px; width: 100%; color: #000000 ; z-index: 1000;position: absolute; bottom: 0;   background-color: #d7d7d7; display: flex;justify-content: center; align-items: center; ">

        <span style=" cursor : pointer"> {{ copyrightName }}</span>
      </div>
    </div>
    <!-- 高德地图 -->
    <div id="containerOne"></div>
  </div>

  <el-dialog v-model="dialogFormVisible" title="故障列表" width="60%">
    <el-row style="text-align: center; margin-bottom: 20px;">
      <!-- <el-col :span="3">车辆编号：</el-col> -->
      <el-col :span="8">
        <el-input v-model="vin" placeholder="请输入车辆编号" size="small" />
      </el-col>
      <el-col :span="8">
        <el-button size="small" type="primary" @click="handsize('s')">搜索</el-button>
        <el-button size="small" type="primary" @click="dialogVisibles = true">批量处理</el-button>
        <el-button size="small" type="primary" @click="del_ignore_all()">全部忽略</el-button>

      </el-col>
    </el-row>
    <el-table :data="buglist" style="width: 100%;" height="300" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" />
      <el-table-column label="编号" width="200" align="center">
        <!-- <template #default="scope">
          <div @click="godiver(scope.row.vin, 4)">
            {{ scope.row.vin }}
          </div>
        </template> -->
        <template #default="scope">
          <div>
            {{ scope.row.vin }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column fixed prop="vin" label="编号" width="200" align="center" /> -->
      <el-table-column prop="fault_message" label="故障信息" width="300" align="center" />
      <el-table-column prop="create_time" label="上报时间" width="200" align="center" />
      <el-table-column label="位置" width="300" align="center">
        <!-- <template #default="scope">
          <div @click="godiver(scope.row.vin, 4)">
            <img src="../../assets/img/weizhi.png" style="width: 10%;height: 10%;" alt /> {{ scope.row.addres }} </div>
        </template> -->
        <template #default="scope">
          <div >
            <img src="../../assets/img/weizhi.png" style="width: 10%;height: 10%;" alt /> {{ scope.row.addres }} </div>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" align="center" width="150">
        <template #default="scope">
          <el-button type="text" size="small" @click="godiver(scope.row.id, 1)">处理</el-button>

          <el-button type="text" size="small" @click="godiver(scope.row.id, 2)">忽略</el-button>
          <!-- <el-button type="text" size="small">批量处理</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background layout="prev, pager, next" :page-size="4" :total="alertnum" @prev-click="handsize"
      @next-click="handsize" @current-change="handsize" />
  </el-dialog>

  <el-dialog v-model="dialogVisibles" title="备注" width="30%">
    <el-input v-model="textarea2" :autosize="{ minRows: 4, maxRows: 4 }" type="textarea" placeholder="请输入" />
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="godiver(3, 3)">提交</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
let wumiaoshijian = ''
import AMap from "AMap";
import * as echarts from "echarts";
import { useStore } from "vuex";
import {
  reactive,
  onMounted,
  toRefs,
  onUpdated,
  onBeforeUnmount,
  ref,
} from "vue";

import { useRouter } from "vue-router";
import {
  get_car_data,
  get_status_number,
  get_car_online_total,
  get_car_status,
  get_car_gps,
  get_bug_list,
  alert_count,
  time_sharing_mileage,
  electricity_consumption,
  deal_alert,
  ignore_alert,
  driving_mode,
  hourly_fault,
  latest_new_vehicle_record,
  ignore_all
} from "../../api/home/api";
let time = '';
let containerOne = null;
let myChartleft2 = null;
let myChartleft3 = null;
let myChartright1 = null;
let myChartright2 = null;
let myChartright3 = null;
let damonth = []
let xmonth = []
var myDate = '';
let mon = '';
let ho = ''
let dahour = []
let xhour = []
let lshuju = []
let rshuju = []
import { ElMessage, ElMessageBox } from 'element-plus'
import { Vue3SeamlessScroll } from "vue3-seamless-scroll";
export default {
  name: "Monitor",
  components: {
    Vue3SeamlessScroll,
  },
  setup() {
    const router = useRouter();
    //echarts 动态获取id 防止切换页面不显示
    const cright1 = ref("chart" + Date.now() + Math.random());
    const cright2 = ref("chart2" + Date.now() + Math.random());
    const cright3 = ref("chart3" + Date.now() + Math.random());
    //vuex
    const Store = useStore();
    // 响应式数据
    const data = reactive({
      code: '',
      vin: '',
      onlinenum: '',
      city: "淄博",
      divshow: true,
      gun_car: '',
      dialogFormVisible: false,
      bugid: '',
      textarea2: '',
      dialogVisibles: false,
      weather: "",
      alertnum: '',
      showbug: false,
      car_data: {},
      car_total: "0",
      car_data_name: ["", "", "", "", "", ""],
      car_data_value: ["", "", "", "", "", ""],
      car_status: [false, false, false, false],

      right3: {
        left: '',
        right: ''
      },
      nowDate: "",
      points: [],
      po: "",
      middle: {},
      right2: {},
      sanitation: {},
      buglist: '',
      selling: {},
      disinfect: {},
      other: {},
      cruiser: {},
      car_gps: {},
      dmonth: '',
      dhour: '',
      dshuju: '',
      hour: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
      month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      left2_value: '',
      left3_value: '',
      options: [],
      input: '',
      page: {
        f: 1,
        s: 4
      },
      d_mo: "",
      d_con: '',
      visible: false,
      fault_num: '',
      car_status_data: {
        name: [],
        value: [{
          bug: "",
          online: '',
          offline: ''
        },
        {
          bug: "",
          online: '',
          offline: ''
        },
        {
          bug: "",
          online: '',
          offline: ''
        },
        {
          bug: "",
          online: '',
          offline: ''
        }]
      },

      copyrightName: "",
    });

    //批处理
    const handleSelectionChange = (val) => {

      data.bugid = val.map(e => e.id).join(',')
    }
    //新增车辆  
    const get_latest_new_vehicle_record = () => {
      latest_new_vehicle_record().then((res) => {
        data.gun_car = res.data
      })
    }
    //处理故障
    const godiver = (id, name) => {
      if (name == 1) {
        data.dialogVisibles = true
        data.bugid = id
      } else if (name == 3) {
        data.dialogVisibles = false
        deal_alert(data.bugid, data.textarea2).then((res) => {
          ElMessage({
            message: res.message,
            type: 'success',
          })
          g_bug_list()
        })
      }
      else if (name == 4) {
        localStorage.setItem("selectTab_item", "Drive");
        localStorage.setItem("vin", id);
        Store.commit('gorouter', "Drive")
        router.push("./Drive");
      }
      else {
        ElMessageBox.alert(' 确定忽略此故障吗', '系统提示', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
        )
          .then(() => {
            ignore_alert(id).then((res) => {
              ElMessage({
                message: res.message,
                type: 'success',
              })
              g_bug_list()
            })

          })


      }

    }
    const del_ignore_all = () => {
      ElMessageBox.alert(' 确定忽略全部故障吗', '系统提示', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }
      )
        .then(() => {
          ignore_all().then((res) => {
            ElMessage({
              message: res.message,
              type: 'success',
            })
            g_bug_list()
          })

        })
    }
    //小时列表   月份列表
    const hourmonth = () => {
      myDate = new Date();
      mon = myDate.getMonth() + 1;
      damonth = []
      xmonth = []
      for (let i in data.month) {
        if (data.month[i] > mon) {
          damonth.push(data.month[i])
        } else {
          xmonth.push(data.month[i])
        }
      }
      data.dmonth = damonth.concat(xmonth)
    }
    //分页查询
    const handsize = (size) => {
      if (size != 's') {
        data.page.f = size
      }
      g_bug_list()
    }

    //故障列表
    const g_bug_list = () => {
      alert_count().then((res) => {
        data.alertnum = res.data
        if (time) {
          clearInterval(time)
        }
        if (data.alertnum > 0) {
          time = setInterval(() => {
            data.divshow = !data.divshow
          }, 1000)
        }
      });
      get_bug_list(data.vin, data.page.f, data.page.s).then((res) => {
        data.buglist = res.data
        for (let i in data.buglist) {
          let lat = data.buglist[i].latitude
          let lng = data.buglist[i].longitude
          if (lat != '-' && lat != '0') {
            data.buglist[i].addres = Number(lng).toFixed(5) + ',' + Number(lat).toFixed(5)
          } else {
            data.buglist[i].addres = '未知'
          }
        }
        data.dialogFormVisible = true
      })
    }
    //左1
    const g_car_data = () => {
      get_car_data().then((res) => {
        data.car_total = res.data.total
        data.car_data_name = []
        data.car_data_value = []
        for (let index = 0; index < res.data.name.length; index++) {
          data.car_data_name[index] = res.data.name[index]
          data.car_data_value[index] = res.data.value[index]
        }
        // for (let index_v = 0; index_v < res.data.name.length; index_v++) {

        // }
      });
    };
    //左二
    const e_consumption = () => {
      electricity_consumption().then((res) => {
        data.left2_value = res.data
        for (let i in data.left2_value) {
          data.left2_value[i] = Number(data.left2_value[i]).toFixed(2)
        }

      })
    }
    //左3
    const t_sharing_mileage = () => {
      time_sharing_mileage().then((res) => {
        data.left3_value = res.data
        for (let i in data.left3_value) {
          data.left3_value[i] = Number(data.left3_value[i]).toFixed(2)
        }

      })
    }
    //中间
    const g_status_number = () => {
      get_status_number().then((res) => {
        if (res.data.total_mileage > 1000) {
          res.data.total_mileage = Number(res.data.total_mileage / 10000).toFixed(1) + ' 万公里'
        } else {
          res.data.total_mileage = Number(res.data.total_mileage).toFixed(1) + ' 公里'
        }
        if (res.data.total_consumption > 10000) {
          res.data.total_consumption = Number(res.data.total_consumption / 10000).toFixed(1) + '(万)'
        } else {
          res.data.total_consumption = Number(res.data.total_consumption).toFixed(1)
        }
        data.middle = res.data;
      });
      alert_count().then((res) => {
        data.alertnum = res.data
        if (time) {
          clearInterval(time)
        }
        if (data.alertnum > 0) {
          time = setInterval(() => {
            data.divshow = !data.divshow
          }, 1000)
        }
      });

    };
    //驾驶模式
    const d_mode = () => {
      driving_mode(data).then((res) => {
        data.d_con = res.count
        data.d_mo = res.data
      })
    }

    //右2  车辆在线统计
    const g_car_online_total = () => {
      get_car_online_total().then((res) => {
        myDate = new Date();
        ho = myDate.getHours();
        dahour = []
        xhour = []
        lshuju = []
        rshuju = []
        for (let i in data.hour) {
          if (data.hour[i] > ho) {
            dahour.push(data.hour[i])
            lshuju.push(res.data[i])
          } else {
            xhour.push(data.hour[i])
            rshuju.push(res.data[i])
          }
        }
        data.dhour = dahour.concat(xhour)
        data.dshuju = lshuju.concat(rshuju)
        data.onlinenum = data.dshuju[23]

      });


    };
    //右4  设备故障统计
    const get_hourly_fault = () => {
      hourly_fault().then((res) => {
        data.fault_num = res.data
      })
    }
    //右5   设备状态 
    const g_car_status = () => {
      get_car_status().then((res) => {
        let len = res.data.name.length
        for (let index = 0; index < 4; index++) {
          if (index < len) {
            data.car_status[index] = true
            data.car_status_data.name[index] = res.data.name[index]
            data.car_status_data.value[index] = res.data.value[index]
          } else {
            data.car_status[index] = false
          }

        }

      });
    };
    //gps
    const g_car_gps = () => {
      get_car_gps().then((res) => {
        data.car_gps = res.data;
      });
    };

    //坐标转换
    const convertFrom = (lnglat, type) => {
      AMap.convertFrom(lnglat, type, function (status, result) {
        if (result.info === "ok") {
          var resLnglat = result.locations[0];
          data.po = { lnglat: [resLnglat.lng, resLnglat.lat] };
          data.points.push(data.po);
          MarkerCluster();
        }
      });
    };
    //聚合点样式
    var _renderClusterMarker = function (context) {
      var count = 6;
      var factor = Math.pow(context.count / count, 1 / 18);
      var div = document.createElement("div");
      var Hue = 180 - factor * 120;
      // var bgColor = 'hsla(120,60%,70%,0.5)';
      var bgColor = "hsla(" + Hue + ",60%,70%,1)";
      var fontColor = "hsla(" + Hue + ",100%,100%,1)";
      var borderColor = "hsla(" + Hue + ",100%,40%,1)";
      var shadowColor = "hsla(" + Hue + ",100%,90%,1)";
      div.style.backgroundColor = bgColor;
      var size = Math.round(20 + Math.pow(context.count / count, 1 / 5) * 20);
      div.style.width = div.style.height = size + "px";
      // div.style.border = 'solid 1px ' + borderColor;
      div.style.borderRadius = size / 2 + "px";
      div.style.boxShadow = "0 0 5px " + shadowColor;
      div.innerHTML = context.count;
      div.style.lineHeight = size + "px";
      div.style.color = fontColor;
      div.style.fontSize = "14px";
      div.style.textAlign = "center";
      context.marker.setOffset(new AMap.Pixel(-size / 2, -size / 2));
      context.marker.setContent(div);
      context.marker.on('click', function (e) {
        var curZoom = containerOne.getZoom();
        if (curZoom < 20) {
          curZoom += 1;
        }
        containerOne.setZoomAndCenter(curZoom, e.lnglat);
      });

    };
    //非聚合点样式
    var _renderMarker = function (context) {
      var count = 6;
      var content =
        '<div style="background-color: hsla(180, 100%, 50%, 0.3); height: 18px; width: 18px; border: 1px solid hsl(180, 100%, 40%); border-radius: 12px; box-shadow: hsl(180, 100%, 50%) 0px 0px 3px;"></div>';
      var offset = new AMap.Pixel(-9, -9);
      context.marker.setContent(content);
      context.marker.setOffset(offset);
    };
    const MarkerCluster = () => {
      var gridSize = 40;
      var cluster = new AMap.MarkerCluster(containerOne, data.points, {
        gridSize: gridSize,
        renderClusterMarker: _renderClusterMarker, // 自定义聚合点样式
        renderMarker: _renderMarker, // 自定义非聚合点样式
      });
    };
    //天气
    const g_city_weather = () => {
      var citysearch = new AMap.CitySearch();
      var weather = new AMap.Weather();
      //自动获取用户IP，返回当前城市
      citysearch.getLocalCity(function (status, result) {
        if (status === "complete" && result.info === "OK") {
          if (result && result.city && result.bounds) {
            var cityinfo = result.city;
            weather.getLive(cityinfo, function (err, datas) {
              if (!err) {
                data.weather = datas
              }
            });
          }
        }
      });
    };
    //实时时间
    const currentTime = () => {
      setInterval(function () {
        myDate = new Date();
        let year = myDate.getFullYear(); // 年
        let month = myDate.getMonth() + 1; // 月
        let day = myDate.getDate(); // 日
        let week = myDate.getDay(); // 星期
        let weekArr = [
          "星期日",
          "星期一",
          "星期二",
          "星期三",
          "星期四",
          "星期五",
          "星期六",
        ];
        let hour = myDate.getHours(); // 时
        hour = hour < 10 ? "0" + hour : hour; // 如果只有一位，则前面补零
        let minute = myDate.getMinutes(); // 分
        minute = minute < 10 ? "0" + minute : minute; // 如果只有一位，则前面补零
        let second = myDate.getSeconds(); // 秒
        second = second < 10 ? "0" + second : second; // 如果只有一位，则前面补零
        data.nowDate = `${year}/${month}/${day}  ${weekArr[week]}  ${hour}:${minute}:${second} `;
      }, 1000);
    };
    //五秒 循环播放
    const shijian = () => {
      wumiaoshijian = setInterval(() => {
        hourmonth()
        g_car_data();
        get_hourly_fault();
        hourly_fault()
        g_car_online_total();
        g_status_number();
        g_car_status();
        t_sharing_mileage()
        d_mode()
      }, 5000)
    }
    //缩放级别位置
    // const zoom = () => {
    //   containerOne.setZoomAndCenter(11.5, [118.060655, 36.814222]); //同时设置地图层级与中心点
    // }
    // const app = (strPath) => {
    //   try {
    //     var objShell = new ActiveXObject("wscript.shell");
    //     objShell.Exec('C:\\Program Files (x86)\\Tencent\\QQMusic\\QQMusic1847.10.18.19\\QQMusic.exe');
    //     objShell = null;
    //   }
    //   catch (e) {
    //     alert('找不到文件')
    //   }
    // }
    const go_con = () => {
      localStorage.setItem("selectTab_item", "./Net_connection");
      router.push("./Net_connection");
    }
    const set_info = () => {
    let value=  localStorage.getItem("info");
     value = JSON.parse(value)
     data.copyrightName=value.copy
     window.document.title = value.cloudControlName
     changeFavicon(value.platformICO)
    }
    const changeFavicon = (img) => {
      let favicon = document.querySelector('link[rel="icon"]')
      if (favicon !== null) {
        favicon.href = img
      } else {
        favicon = document.createElement('link')
        favicon.rel = 'icon'
        favicon.href = './public/favicon.ico'
        document.head.appendChild(favicon)
      }
    }
    set_info()
    hourmonth()
    d_mode()
    g_car_data();
    get_hourly_fault()
    g_car_online_total();
    g_status_number();
    g_car_status();
    g_city_weather();
    t_sharing_mileage()
    e_consumption()
    g_car_gps();
    shijian()
    currentTime();
    get_latest_new_vehicle_record()
    //挂载 echarts和 高德地图
    onMounted(() => {
      //延迟一秒拿数据
      setTimeout(function () {
        // 配置高德地图
        let opts = {
          subdistrict: 0,
          extensions: "all",
          level: "city",
        };
        //给地图描边
        let district = new AMap.DistrictSearch(opts);
        district.search("中国", function (status, result) {
          let bounds = result.districtList[0].boundaries;
          let mask = [];
          for (let i = 0; i < bounds.length; i += 1) {
            mask.push([bounds[i]]);
          }
          // 加载高德地图 位置大小
          containerOne = new AMap.Map("containerOne", {
            mask: mask,
            center: [105.472804, 39.995725],
            zoom: 4.8,
          });
          let longitude = ''
          let latitude = ''
          var lnglat = ''
          let type = "";
          for (let i = 0; i < data.car_gps.length; i++) {
            // 创建gps坐标位置点标记
            longitude = data.car_gps[i].longitude;
            latitude = data.car_gps[i].latitude;
            lnglat = [longitude, latitude];
            type = "";
            //判断坐标类型
            if (data.car_gps[i].gps_type === "baidu") {
              type = "baidu";
              convertFrom(lnglat, type);
            } else if (data.car_gps[i].gps_type === "google") {
              type = "google";
              convertFrom(lnglat, type);
            } else if (data.car_gps[i].gps_type === "gps") {

              type = "gps";

              convertFrom(lnglat, type);
            } else {
              data.po = { lnglat: [longitude, latitude] };
              data.points.push(data.po);
            }
          }
          MarkerCluster();
          // 加载高德地图 皮肤
          let styleName = "amap://styles/270733bbb12c36d9bd368103b6a9e244";
          containerOne.setMapStyle(styleName);
          // 加载中国地图
          for (let m = 0; m < bounds.length; m += 1) {
            new AMap.Polyline({
              path: bounds[m],
              // strokeColor: '#829bff',
              // strokeWeight: 5,
              strokeColor: "#00b8ff",
              strokeWeight: 4,
              strokeOpacity: 0.9,
              zIndex: 50,
              bubble: true,
              map: containerOne,
            });
          }
        });
      }, 1000);

      //分时里程数 echarts
      let left2 = document.getElementById("left2");
      myChartleft2 = echarts.init(left2);
      let optionleft2 = {
        backgroundColor: "rgba(43,74,118,0)",
        title: {
          textStyle: {
            color: "#00FFFF",
          },
        },
        grid: {
          height: 145,
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            return '<div>' + params[0].name + '时' + '<br>' + params[0].marker + params[0].seriesName + ':' + '<span style="color: #00B83F;">' + params[0].value + '</span>Km' + '</div>';
          }
        },

        legend: {
          data: ["分时里程数"],
          top: 20,
          textStyle: {
            color: "#ffffff",
          },
        },

        xAxis: {
          type: "category",
          name: "时",
          boundaryGap: false,
          data: data.hour,
          scale: true,
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#fff",
            },
          },
        },
        yAxis: [
          {
            type: "value",
            name: "Km",
            show: true,
            splitLine: {
              show: false,
            },

            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff",
              },
            },

            axisLabel: {
              formatter: "{value}",
            },
          },

        ],
        series: [
          {
            name: "分时里程数",
            type: "line",
            itemStyle: {
              color: "#ffcc00",
            },
            data: data.left3_value,
          },

        ],
      };

      optionleft2 && myChartleft2.setOption(optionleft2);

      //左边第二个echarts  用电量
      let left3 = document.getElementById("left3");
      myChartleft3 = echarts.init(left3);
      let optionleft3 = {
        legend: {
          data: ["昨日用电量"],
          top: 20,
          textStyle: {
            color: "#ffffff",
          },
        },
        tooltip: {
          trigger: 'axis', //坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
          formatter: function (params) {
            return '<div>' + params[0].name + '时' + '<br>' + params[0].marker + '用电量' + ':' + '<span style="color: #00B83F;">' + params[0].value + '</span>Kwh' + '</div>';
          }
          // axisPointer: {// 坐标轴指示器，坐标轴触发有效
          // 	type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          // }
        },
        grid: {
          height: 155,
          backgroundColor: "rgba(0,0,0,0)",
        },
        xAxis: {
          type: 'category',
          name: "时",
          data: data.hour,
          axisLine: {
            lineStyle: {
              color: "#fff",
            },
          },
        },
        yAxis: [
          {
            type: 'value',
            name: "(Kwh)",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff",
              },
            },
          }, {
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              formatter: "{value} ",
            },
          }
        ],
        series: [
          {
            data: data.left2_value,
            type: 'bar',
            name: "昨日用电量",
            showBackground: true,
            itemStyle: {
              color: "#e5bc0f",
            },
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)'
            }
          }
        ]
      };

      optionleft3 && myChartleft3.setOption(optionleft3);

      //    驾驶模式
      var right1 = document.getElementById(cright1.value);
      myChartright1 = echarts.init(right1);

      let optionright1 = {
        // backgroundColor: 'rgba(43,74,118,0)',
        tooltip: {
          trigger: "item",
          // formatter: function (params) {
          //   return '<div>' + params[0].name + '<br>' + params[0].marker + params[0].seriesName  + ':' + '<span style="color: #00B83F;">' + params[0].value + '</span>辆' + '</div>';
          // }
        },
        legend: {
          type: "scroll",
          orient: "vertical",
          right: 10,
          top: 30,
          bottom: 20,
          textStyle: {
            //图例文字的样式
            color: "#fff",
            fontSize: 13,
          },
        },

        series: [
          {
            type: "pie",
            radius: ["40%", "60%"],
            center: ["50%", "45%"],
            avoidLabelOverlap: false,
            top: 1,
            width: "60%",
            label: {
              normal: {
                show: true,
                position: 'center',
                formatter: function () {
                  return data.d_con
                },
                textStyle: {
                  color: "#ffffff", // 改变标示文字的颜色
                },
              }
            },

            data: data.d_mo,
          },
        ],
      };
      optionright1 && myChartright1.setOption(optionright1);

      //在线车辆
      var right2 = document.getElementById(cright2.value);
      myChartright2 = echarts.init(right2);
      let optionright2 = {
        backgroundColor: "rgba(43,74,118,0)",
        grid: {
          height: 110,
          bottom: 90,
          left: 60,
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            return '<div>' + params[0].name + '时' + '<br>' + params[0].marker + '在线车辆' + ':' + '<span style="color: #00B83F;">' + params[0].value + '</span>辆' + '</div>';
          }
        },

        xAxis: {
          type: "category",
          name: "时",
          data: data.dhour,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#fff",
            },
          },
        },
        yAxis: {
          type: "value",
          name: "辆",
          splitLine: { show: false },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#fff",
            },
          },
        },

        series: [
          {
            name: "分时在线车辆",
            type: "line",
            data: data.dshuju,
            areaStyle: { color: "#1089f5" },
          },
        ],
      };
      optionright2 && myChartright2.setOption(optionright2);


      //故障数量
      var right3 = document.getElementById(cright3.value);
      myChartright3 = echarts.init(right3);
      var optionright3 = {
        grid: {
          height: 150,
          bottom: 50,
          left: 60,
        },
        xAxis: {
          type: 'category',
          data: data.dhour
        },
        yAxis: {
          type: 'value',
          //   splitLine: { show: false },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#fff",
            },
          },
        },
        series: [
          {
            data: data.fault_num,
            type: 'line',
            smooth: true,
            lineStyle: { // 设置线条的style等
              normal: {
                color: 'yellow',
              },
            }
          }
        ]
      };

      optionright3 && myChartright3.setOption(optionright3);
    });
    //监听数据 更新echarts
    onUpdated(() => {
      myChartright2.setOption({
        xAxis: {
          type: "category",
          data: data.dhour,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#fff",
            },
          },
        },
        series: [
          {
            name: "分时在线车辆",
            type: "line",
            data: data.dshuju,
            areaStyle: { color: "#1089f5" },
          },
        ],
      });
      myChartright3.setOption({
        xAxis: {
          type: 'category',
          data: data.dhour
        },

        series: [
          {
            data: data.fault_num,
            type: 'line',
            smooth: true
          }
        ]



      });
      myChartleft2.setOption({
        xAxis: {
          type: "category",
          name: "时",
          boundaryGap: false,
          data: data.dhour,
          scale: true,
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#fff",
            },
          },
        },

        series: [
          {
            name: "分时里程数",
            type: "line",
            itemStyle: {
              color: "#ffcc00",
            },
            data: data.left3_value,
          },

        ],
      });
      myChartleft3.setOption({
        series: [
          {
            data: data.left2_value,
          },
        ],
      });

      myChartright1.setOption({
        series: [
          {
            type: "pie",
            radius: ["40%", "60%"],
            center: ["50%", "45%"],
            avoidLabelOverlap: false,
            top: 1,
            width: "60%",
            label: {
              normal: {
                show: true,
                position: 'center',
                formatter: function () {
                  return data.d_con
                },
                textStyle: {
                  color: "#ffffff", // 改变标示文字的颜色
                  fontSize: 26,
                  fontWeight: 'bold',
                },
              }
            },
            data: data.d_mo,
          },
        ],
      })

    });
    //离开页面之前销毁计时器和 地图
    onBeforeUnmount(() => {
      if (time) {
        clearInterval(time) // 在Vue实例销毁前，清除时间定时器
      }
      if (wumiaoshijian) {
        clearInterval(wumiaoshijian) // 在Vue实例销毁前，清除时间定时器
      }
      if (containerOne) {
        containerOne && containerOne.destroy();
      }

    });
    // 返回数据;
    return {
      ...toRefs(data),
      g_car_data,
      g_status_number,
      g_car_online_total,
      g_car_status,
      g_car_gps,
      convertFrom,
      g_city_weather,
      currentTime,
      MarkerCluster,
      _renderClusterMarker,
      _renderMarker,
      g_bug_list,
      godiver,
      handsize,
      cright1,
      cright2,
      cright3,
      handleSelectionChange,
      app,
      go_con,
      del_ignore_all
    };
  },
};
</script>
<style lang="scss" scoped>
.amap-container {
  background-color: rgba(58, 179, 85, 0) !important;
}

#containerOne {
  margin: 0;
  width: 100%;
  height: 100%;
}

/deep/.amap-copyright {
  font-size: 0px;
}

/deep/.amap-logo img {
  height: 0px !important;
  width: 0px !important;
}

/deep/ .el-select .el-input__inner {
  background-color: rgba(255, 228, 196, 0);
  color: rgb(213, 255, 25);
}

.left {
  width: 22%;
  height: 100%;
  position: absolute;
  z-index: 100;
}

.left1_back {
  width: 100%;
  height: 7%;

  background-image: url("../../assets/img/title_bg.png");
  font-size: 16px;
  color: #ffffff;
  background-size: 100% 100%;
  position: relative;
}

.left_img {
  min-width: 100px;
  min-height: 100px;
  max-height: 300px;
  max-width: 300px;
  background-image: url("../../assets/img/data_box.png");
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.title_back {
  width: 100%;
  height: 7%;
  background-image: url("../../assets/img/title_bg.png");
  font-size: 16px;
  color: #ffffff;
  background-size: 100% 100%;
  position: relative;
}

.weather {
  height: 100%;
  width: 18%;
  background-image: url("../../assets/img/weather.png");
  background-size: 100% 100%;
}

.leftbox {
  width: 90%;
  height: 100%;
  margin: 0 auto;
}

.left2 {
  width: 100%;
  height: 100%;
}

.middle {
  width: 100%;
  height: 10%;
  z-index: 90;
  position: absolute;
  display: flex;
}

.middle_li {
  width: 21%;
  height: 80%;
  background-image: url("../../assets/img/11_zbk.png");
  background-size: 100% 100%;
  text-align: center;
  font-size: 1.1rem;
  color: #ffffff;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.middle_li2 {
  width: 21%;
  height: 80%;
  background-image: url("../../assets/img/22_zbk.png");
  background-size: 100% 100%;
  text-align: center;
  font-size: 1.1rem;
  color: #ffffff;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.middle_li3 {
  width: 21%;
  height: 80%;
  background-image: url("../../assets/img/33_zbk.png");
  background-size: 100% 100%;
  text-align: center;
  font-size: 1.1rem;
  color: #ffffff;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.middle_li4 {
  width: 21%;
  height: 80%;
  background-image: url("../../assets/img/44_zbk.png");
  background-size: 100% 100%;
  text-align: center;
  font-size: 1.1rem;
  color: #ffffff;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.middle_li5 {
  width: 21%;
  height: 80%;
  background-image: url("../../assets/img/55_zbk.png");
  background-size: 100% 100%;
  text-align: center;
  font-size: 1.1rem;
  color: #ffffff;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.middle_li img {
  width: 80%;
  height: 80%;
}

.middle_li ul {
  list-style: none;
  position: absolute;
  top: 20%;
  left: 50%;
}

.right2 {
  width: 100%;
  height: 100%;
}

.right {
  width: 22%;
  height: 98%;
  position: absolute;
  z-index: 100;
  right: 0;
}

.rightbox {
  width: 90%;
  height: 100%;
  margin: 0 auto;
}

.right5 {
  height: 100%;
  width: 15%;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  writing-mode: vertical-rl;
  background-image: linear-gradient(#25ffa6, rgba(6, 74, 186, 0.34));
}

.right_back {
  width: 45%;
  height: 100%;
  display: flex;
  background-image: radial-gradient(rgba(123, 211, 255, 0.19) 0%,
      rgba(6, 74, 186, 0.12));
}

.user_skills {
  font-size: 13px;
  height: 10%;
  width: 100%;
  padding-left: 4%;
}

.user_skills dox {
  height: 80%;
  width: 100%;
}

.el-scrollbar__wrap {
  overflow-x: hidden;
}

.scroll {
  height: 50px;
  width: 500px;
  overflow: hidden;
}

.scroll .item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px 0;
}
</style>